export function getPageName(): string {
  let name: string = '';
  if (typeof window === 'undefined') return '';
  if (window.location.pathname === '/search') {
    name = 'Search';
  } else if (window.page_name) {
    name = window.page_name;
  }
  return name;
}
